<template>
  <div>
    <el-select
      filterable
      v-model="selectedValue"
      v-if="isBikeType"
      key="multiple"
      :multiple="multiple"
      :disabled="disabled"
      :clearable="!required"
      :placeholder="required ? '必选' : '非必选'"
    >
      <el-option v-for="item in optionList" :label="item.label" :value="item.value" :key="item.value">
      </el-option>
    </el-select>

    <el-select
      filterable
      v-model="selectedValue"
      v-else
      :disabled="disabled"
      key="single"
      :clearable="!required"
      :placeholder="required ? '必选' : '非必选'"
    >
      <el-option v-for="item in optionList" :label="item.label" :value="item.value" :key="item.value">
      </el-option>
    </el-select>
  </div>

  
</template>

<script>
export default {
  name: 'filter-charge-type',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    businessLine: {
      type: Number,
      default: 1203
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
        this.$emit('change', val)
      },
    },
    optionList() {
      return +this.businessLine === 1203 ?
      [
        {
          label: '包天',
          value: 2,
        },
        {
          label: '计件',
          value: 1,
        }
      ] :
      [
        {
          label: '包时',
          value: 3,
        },
        {
          label: '计件',
          value: 1,
        },
        {
          label: '计件+包时',
          value: '1,3',
        },
      ]
    },
    isBikeType() {
      console.log(this.businessLine)
      return +this.businessLine === 1204
    }
  },

  // watch: {
  //   businessLine: {
  //     immediate: true,
  //     handler(val) {
  //       this.selectedValue = null
  //     },
  //   }
  // },

  created() {
    if (this.required) {
      this.selectedValue = this.optionList[0].value
    }
  },
}
</script>
